import { render, staticRenderFns } from "./approvalRadio.vue?vue&type=template&id=13ae448a"
import script from "./approvalRadio.vue?vue&type=script&lang=js"
export * from "./approvalRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports